export const routes = {
    dashboard: {
        dashboard: '/dashboard',
    },
    auth: {
        login: '/login',
        signup: '/signup',
        requestResetPassword: '/request-password',
        resetPassword: '/reset-password',
        logout: '/logout',
    },
    commissions: {
        list: '/commissions',
        detail: '/commissions/:id',
        new: '/commissions/new',
        export: '/commissions/export/:id',
    },
    carriers: {
        list: '/carriers',
        detail: '/carriers/:id',
        new: '/carriers/new',
    },
    customers: {
        list: '/customers',
        detail: '/customers/:id',
        new: '/customers/new',
    },
    invoicing: {
        list: '/invoicing',
        detail: '/invoicing/:id',
        new: '/invoicing/new',
    },
    offers: {
        list: '/offers',
        detail: '/offers/:id',
        new: '/offers/new',
    },
    profile: '/profile',
    dispatcher: {
        list: '/dispatcher',
        detail: '/dispatcher/:id',
        new: '/dispatcher/new',
        onboarding: 'dispatcher/onboarding',
    },
    attachments: {
        upload: '/attachment/upload',
        detail: '/attachment/:id',
        new: '/attachment/new',
    },
} as const;
